import fetch ,{postFrom} from "../utils/fetch";

// 根据主合同code查询合同信息

export function getFinContractInfo(parentContractCode) {
  return fetch({
    method: 'GET',
    url: 'certificate/getFinContractInfo/parentContractCode',
    params:{
      parentContractCode
    }
  })
}

// // 根据合同code查询合同信息
export function getSubContractInfo(contractCode) {
  return fetch({
    method: 'GET',
    url: 'certificate/getFinContractInfo/contractCode',
    params:{
      contractCode
    }
  })
}

// 企业应收账单明细
export function getEpsBillDetail(parentContractCode,periods) {
  return fetch({
    method: 'GET',
    url: 'bill/getEpsBillDetail',
    params:{
      parentContractCode,
      periods
    }
  })
}

// 用户可用租金卡
export function queryRentCard(uid) {
  return fetch({
    method: 'GET',
    url: 'certificate/queryRentCard',
    params:{
      uid
    }
  })
}

// 批量保存缴费凭证
export function batchSaveCertificate(data) {
  return fetch({
    method: 'POST',
    url: 'certificate/batchSaveCertificate',
    data
  })
}

// 应收账单列表
export function getList(params) {
  return fetch({
    method: 'GET',
    url: 'bill/getList',
    params
  })
}

// 应收账单列表条件
export function getConditions() {
  return fetch({
    method: 'GET',
    url: 'bill/getConditions'
  })
}

// 作废账单
export function deleteReceivableBill(billNumber) {
  return fetch({
    method: 'POST',
    url: 'bill/deleteReceivableBill',
    data:{
      billNums:[billNumber],
      isDel:1
    }
  })
}

// 应收账单详情  账单编号获取详情接口
export function getBillInfo(contractCode,billNum) {
  return fetch({
    method: 'GET',
    url: 'bill/findBillInfoByContractCode',
    params:{
      contractCode,
      billNum
    }
  })
}

// 应收账单详情  收款操作取详情接口
export function getBillInfoByCollect(conRentCode,billNum) {
  return fetch({
    method: 'GET',
    url: 'bill/getReceivableBill',
    params:{
      conRentCode,
      billNum
    }
  })
}
// 费用项枚举

export function getFeeItems() {
  return fetch({
    method: 'GET',
    url: 'bill/getCostCodeEnumConditions'
  })
}

//新建应收账单 费用项枚举
export function getReceivableCostItem() {
  return fetch({
    method: 'GET',
    url: 'bill/getReceivableCostItem'
  })
}



// 新建应收账单
export function createBill(data) {
  return fetch({
    method: 'POST',
    url: 'bill/create',
    data
  })
}

// 缴费凭证详情
export function certificateDetail(projectFid,billNum) {
  return fetch({
    method: 'GET',
    url: 'certificate/detail',
    params:{
      projectFid,
      billNum
    }
  })
}

// pos机终端号查询 posSetting/queryTerminal

export function getPosTerminal(projectFid,bankName) {
  return fetch({
    method: 'GET',
    url: 'posSetting/queryTerminal',
    params:{
      bankName,
      projectFid
    }
  })
}

// 单个收款
export function savePaymentVoucher(data) {
  return fetch({
    method: 'POST',
    url: 'certificate/savePaymentVoucher',
    data
  })
}
//修改缴费凭证
export function updatePaymentVoucher(data) {
  return fetch({
    method: 'POST',
    url: 'certificate/updatePaymentVoucher',
    data
  })
}

// 查询收款方式
export function getReceiptMethod(contractCode) {
  return fetch({
    method: 'GET',
    url: 'certificate/getReceiptMethod',
    params:{
      contractCode
    }
  })
}

// 重复收款校验
export function canCertificate(params) {
  return fetch({
    method: 'GET',
    url: '/bill/canCertificate',
    params
  })
}

// 工作台回款数量
export function getReceiveNum(params) {
  return fetch({
    method: 'GET',
    url: 'certificate/getReceiveNum',
    params
  })
}


// 工作台回款列表
export function getReceiveList(params) {
  return fetch({
    method:'POST',
    url:'certificate/getReceiveList',
    data:params
  })
}

// 工作台保存回款列表跟进记录
export function saveReceiveFollow(params) {
  return fetch({
    method:'POST',
    url:'certificate/saveReceiveFollow',
    data:params
  })
}

// 工作台查询回款列表跟进记录
export function getReceiveFollow(params) {
  return fetch({
    method: 'GET',
    url: 'certificate/getReceiveFollow',
    params
  })
}
